import type { Components, Theme } from "@mui/material/styles";

export const MuiDialogActions: Components<Theme>["MuiDialogActions"] = {
  styleOverrides: {
    root: {
      paddingInline: "var(--spacing-page)",
      paddingBlock: "calc(var(--spacing) * 4)",
    },
  },
};
